<div (window:resize)="onResize($event)" class="mi-grid-component passengerDayBokingGrid"
  [ngClass]="[overflowShow ? 'overflow-show' :  '', (!bottomSearchBar && topBorder) ? 'top-border' : '', (dataLoaded && !datasource?.length) ? 'mi-grid--empty' : '']"
  [style.--mi-grid-viewport-height]="gridScrollHeight">
  <div id="p-table-list">
    <div class="search-and-export-data-panel" style="display: flex;">
      <div class="mi-grid-layout-container col-12 ml-0-8">
        <div class="search-section">
          <label *ngIf="!bottomSearchBar" for="search-bar" title="Search" class="fa fa-search input-icon"></label>
          <input *ngIf="!bottomSearchBar" pInputText type="text" class="grid-search-bar top" [(ngModel)]="search"
            (keyup)="onQuickFilterChanged($event, dt)" [placeholder]="searchPlaceHolderValue"
            [style]="{'width': searchWidth + 'px'}"/>
          <label *ngIf="!bottomSearchBar && search !== ''" (click)="onResetSearchInput()" for="search-bar"
            [title]="clearSearch" class="fa fa-close input-close-icon"></label>
        </div>

        <!--  SHow legend Action -->



        <div class="export-section" *ngIf="pagination && !openSidebar">
                    <div class="pagination-controls">
            <p-paginator [rows]="paginationPageSize" [totalRecords]="totalRecords" [first]="offset"
              (onPageChange)="onPageChange($event)" [showCurrentPageReport]="true"
              currentPageReportTemplate="{first} - {last} of {totalRecords}" [showFirstLastIcon]="false"
              [showPageLinks]="false" [showJumpToPageDropdown]="false">
            </p-paginator>
          </div>
             <!--  ------------------------------------------------------------xle file export import  -->


        </div>
      </div>
    </div>

       <!--  ------------------------------------------------------------search functionality  -->

    <div class="scroll-bar-css"
      [class.mi-grid-scroll--empty]="dataLoaded && !datasource?.length"
      (scroll)="onChangeScroll($event)"
      [ngStyle]="{
        'max-height': gridScrollHeight,
        'min-height': gridScrollHeight,
        'height': gridScrollHeight,
        'overflow-y': (dataLoaded && !datasource?.length) ? 'hidden' : 'auto',
        'overflow-x': 'hidden'
      }">
      <div class="col-12 grid-content-data">
        <p-table #dt [ngClass]="isDetailScreen ? 'detail-screen-available' : ''" [lazy]="true"
          [rows]="paginationPageSize" metaKeySelection="false" [value]="datasource" [paginator]="false"
          [totalRecords]="totalRecords" (onLazyLoad)="loadDatasourceLazy($event)" [selectionMode]="rowSelection"
          (onRowSelect)="onRowSelect($event)" (onRowUnselect)="onRowUnselect($event)" [(selection)]="selectedRecords"
          [resizableColumns]="enableResizer" [first]="offset"
          [scrollable]="gridScrollable"
          [scrollHeight]="gridTableScrollHeight" >

          <ng-template pTemplate="header">
            <tr >
              <ng-container *ngFor="let col of columnDefs">
                <th *ngIf="col.allShuttleSidebar" style="text-align: center; width: 50px;">
                  <p-tableHeaderCheckbox [value]="selectedCheckbox" (click)="onSelectAllCheckboxClick($event)"></p-tableHeaderCheckbox>
                </th>
                <th *ngIf="col.mergePopupCheckbox" style="width:50px">
                  <input type="checkbox" [ngModel]="selectedMergeCheckbox" (click)="onMergeSelectAllCheckboxClick($event)" />
                </th>
                <th *ngIf="col.resize && enableResizer && !col.allShuttleSidebar && !col.mergePopupCheckbox" pResizableColumn
                  [pSortableColumn]="(col?.sort) ? col?.sortField ? col?.sortField : col.field: ''" [width]="col?.width"
                  title="{{col?.header}}" [ngClass]="col?.class ? col.class : ''"
                  [ngStyle]="{'padding-left': col?.sort?'':'10px'}">

                  <span class="mi-grid-header-cell">
                    <p-sortIcon *ngIf="col?.sort" [field]="col.field"></p-sortIcon>
                    <span class="mi-grid-header-label">{{col.header}}</span>
                  </span>
                </th>
                <th *ngIf="!col.resize && !col.allShuttleSidebar && !col.mergePopupCheckbox" [pSortableColumn]="(col?.sort) ? col.field: ''" title="{{col.header}}"
                  [width]="col?.width" [ngClass]="col?.class ? col.class : ''">
                  <span class="mi-grid-header-cell">
                    <p-sortIcon *ngIf="col?.sort" [field]="col.field"></p-sortIcon>
                    <span class="mi-grid-header-label">{{col.header}}</span>
                  </span>
                </th>
              </ng-container>

              <th style="text-align: center;" *ngIf="actionButtonsDefs.length">
                Action
              </th>

            </tr>
          </ng-template>
          <ng-template pTemplate="emptymessage">
            <ng-container *ngIf="!dataLoaded; else emptyState">
              <tr *ngFor="let _ of skeletonRows" class="mi-grid-skeleton-row">
                <td *ngFor="let col of columnDefs" [width]="col?.width" [ngClass]="col?.class ? col.class : ''">
                  <p-skeleton width="80%" height="1.75rem" borderRadius="15px"></p-skeleton>
                </td>
                <td *ngIf="actionButtonsDefs.length" style="text-align: center;">
                  <p-skeleton width="2rem" height="1.75rem"></p-skeleton>
                </td>
              </tr>
            </ng-container>
            <ng-template #emptyState>
              <tr class="mi-grid-empty-row">
                <td [attr.colspan]="columnDefs.length + (actionButtonsDefs.length ? 1 : 0)">
                  <div class="mi-grid-empty-state">
                    <img src="assets/images/temp/no_data.svg" alt="No records found" class="mi-grid-empty-state__image" />
                    <p class="mi-grid-empty-state__message">{{ resolvedEmptyMessage | translate }}</p>
                    <ng-container *ngIf="showEmptyStateTemplate">
                      <ng-container *ngTemplateOutlet="emptyStateTemplate"></ng-container>
                    </ng-container>
                  </div>
                </td>
              </tr>
            </ng-template>
          </ng-template>
          <ng-template pTemplate="body" let-rowData let-columns="columnDefs" let-rowIndex="rowIndex">
            <tr [pSelectableRow]="rowData" [pSelectableRowIndex]="rowIndex" [class]="rowIndex%2==0?'even-row':'odd-row'"
              [ngStyle]="{
                'background-color': rowData['rowBgColorCode'] ? rowData['rowBgColorCode'] : '',
                '--flash-color': rowData['showAlertForSpecialRequestColor'] ? toRgba20(rowData['showAlertForSpecialRequestColor']) : (rowData['rowBgColorCode'] ? toRgba20(rowData['rowBgColorCode']) : ''),
                '--flash-color-rgb': rowData['showAlertForSpecialRequestColor'] ? toRgbTriplet(rowData['showAlertForSpecialRequestColor']) : (rowData['rowBgColorCode'] ? toRgbTriplet(rowData['rowBgColorCode']) : '')
              }"
              [ngClass]="isEmergency(rowData) ? 'flash-emergency-row' : ''">
              <td [ngClass]="[col?.class ? col.class : '', col?.isDropDown ? 'visible-dropdown' : '']"
                *ngFor="let col of columnDefs" [ngStyle]="{'max-width': col?.width? col?.width+'px':''} ">
                <div class="grid-dropdown-section filter-drop-down width-100per"
                  [ngClass]="[col?.condColorClass ? getDropdownColor(rowData): '', col?.class ? col.class : '', col?.cellRendererHtml ? 'grid-stacked-cell' : '', col?.dropdownClass ? col.dropdownClass(rowData) : '']"
                  *ngIf="col?.isDropDown">
                  <div [ngClass]="col?.cellRendererHtml ? 'grid-stacked-cell-primary noCSS' : 'noCSS'">
                    <p-dropdown #gridDropdown
                      [options]="(rowData[col.subServiceType] === subServiceThirdParty)?col.thirdPartyOptions:col.options"
                      [disabled]="isColumnDropdownDisabled(col, rowData)" [placeholder]="'label_select' | translate"
                      [(ngModel)]="rowData[col.field]" [style]="{'width':'100%','border-radius': '4px',
                    'border': isColumnDropdownDisabled(col, rowData) ? 'solid 1px #b0b0b0' : 'solid 1px #323232',
                    'background-color': isColumnDropdownDisabled(col, rowData) ? '#dedede' : 'white'}" data-action-type="DROP-DOWN" (click)="onDropDownClick($event, rowData)"
                      (onChange)="onDropDownChange($event, rowData, col?.type)"
                      (onShow)="onGridDropdownShow(gridDropdown)"
                      (onHide)="onGridDropdownHide(gridDropdown)"
                      appendTo="body"
                      [title]="getDropdownLabel(col.options, rowData[col.field])">
                    </p-dropdown>
                  </div>
                  <div class="grid-dropdown-extra-content noCSS"
                    *ngIf="col?.cellRendererHtml && getRowCellHtml(rowData, col.field)"
                    [innerHtml]="getRowCellHtml(rowData, col.field)">
                  </div>
                  <div *ngIf="col?.isEditField && (rowData[col.subServiceType] !== subServiceThirdParty)"
                    class="sm:col-12 md:col-12 lg:col-12">
                    <div class="grid flex justify-content-start align-items-center">

                      <div class="col-12 grid p-0 m-0 flex justify-content-start align-items-start">
                        <div class="col-5 p-0 noCSS mr-2"
                          *ngIf="rowData[col.pickUpEtaStr] && rowData[col.bookingStatus] == 80">
                          <div class="pickupETA noCSS p-1 greenBox" (click)="onEtaClick($event, rowData)"
                            [id]="rowData.id">
                            Pickup ETA: {{rowData[col.pickUpEtaStr]}}
                          </div>
                        </div>

                        <div class="col-5 noCSS p-0" *ngIf="rowData[col.estimatedDropOffTimeStr]">
                          <div class="dropETA noCSS" [id]="rowData.id"
                            [ngClass]="(rowData[col.bookingStatus] === 130 || rowData[col.bookingStatus] === 90) ? 'cursorPointer' : ''"
                            (click)="(rowData[col.bookingStatus] === 130 || rowData[col.bookingStatus] === 90) ? onEtaClick($event, rowData) : null">
                            Drop
                            Off
                            ETA :
                            {{rowData[col.estimatedDropOffTimeStr]}}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 grid m-0 mt-1 flex justify-content-start align-items-start" *ngIf="rowData[col.flightDetailsNote]"   [ngClass]="{
                        'red-text': rowData[col.delayedArrival],
                        'green-text': !rowData[col.delayedArrival] && rowData[col.earlyArrival],
                        'blue-text': !rowData[col.delayedArrival] && !rowData[col.earlyArrival]
                      }" style="width: 100%;">
                        <span [title]="rowData[col.flightDetailsNote]" style="display: inline-block; max-width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                          {{rowData[col.flightDetailsNote]}}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div *ngIf="col?.isSwitchBtn">
                  <p-inputSwitch (onChange)="onSwitchChange($event, rowData)"
                    [disabled]="(!rowData[col.disableField] && !rowData[col.field]) || col.isDisable"
                    [(ngModel)]="rowData[col.field]">
                  </p-inputSwitch>
                </div>

                <div *ngIf="col.cellRendererHtml == undefined && !col?.isDropDown && !col?.isSwitchBtn">
                  <span [title]="rowData[col.field]" *ngIf="col?.bold" class="apply-500-font">{{(rowData[col.field] ===
                    null || rowData[col.field] === '') ? defaultNull : rowData[col.field]}}</span>
                  <span [title]="rowData[col.field]?rowData[col.field]:defaultNull" *ngIf="!col?.bold">{{(rowData[col.field]
                    ===
                    null || rowData[col.field] === '') ? defaultNull : rowData[col.field]}}</span>
                </div>

                <div class="grid-cell-renderer noCSS" *ngIf="col.cellRendererHtml != undefined && !col?.isDropDown && !col?.isSwitchBtn"
                  [innerHtml]="rowData[col.field]">
                </div>
                <div *ngIf="col?.allShuttleSidebar">
                  <input type="checkbox" [ngModel]="selectedCheckbox" (click)="onCheckboxClick($event,rowData)" />

                  <!-- Row Checkbox -->


                </div>
                <div *ngIf="col?.mergePopupCheckbox" class="merge-popup-checkbox-column">
                  <input type="checkbox" [ngModel]="isMergeRowSelected(rowData)" (click)="onMergeCheckboxClick($event, rowData)" />
                </div>
                <div *ngIf="col?.assignDriverPopup" class="position-relative">
                  <input [id]="rowIndex" type="text" class="grid-search-bar top"
                    [value]="rowData.driverFirstName? rowData.driverFirstName +' '+ rowData.driverLastName: ''"
                    placeholder="Select Driver" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="ASSIGN-DRIVER-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.assignShuttlePopup" class="position-relative">
                  <input type="text" class="grid-search-bar top" [value]="rowData.busName? rowData.busName: ''"
                    placeholder="Select Shuttle" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="ASSIGN-SHUTTLE-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.showDriverPopup" class="position-relative">
                  <input [id]="rowIndex" type="text" class="grid-search-bar top"
                    [value]="rowData.driverFirstName ? rowData.driverFirstName +' '+ rowData.driverLastName : (rowData?.id == selectedDriverData?.tourId ? selectedDriverData?.fullName : (selectedDriverData?.tourIdList?.includes(rowData?.id) ? selectedDriverData?.fullName : ''))"
                    placeholder="Select Driver" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="SELECT-DRIVER-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.showShuttlePopup" class="position-relative">
                  <input [id]="rowIndex" type="text" class="grid-search-bar top"
                    [value]="rowData.busName ? rowData.busName : (rowData?.id == selectedBusData?.tourId ? selectedBusData?.busName : (selectedBusData?.tourIdList?.includes(rowData?.id) ? selectedBusData?.busName : ''))"
                    placeholder="Select Shuttle" readonly />
                  <i class="fa fa-fw fa-plus assignDriverShuttleIcon" data-action-type="SELECT-SHUTTLE-POPUP"
                    (click)="onSelectClick($event)"></i>
                </div>

                <div *ngIf="col?.fromToArrow">
                  <li class="sprite fa-right-side-arrow"></li>
                </div>
              </td>

              <td [ngClass]="col?.class ? col.class : ''" *ngIf="actionButtonsDefs.length">
                <span *ngFor="let btn of actionButtonsDefs">
                  <button *ngIf="rowData[btn.field] !== 'deactivated'" (click)="actionBtnClick(rowData, btn.class)"
                    [icon]="btn.icon" [title]="btn?.label" pButton appRipple appRipple [label]="btn?.heading" pButton
                    appRipple appRipple [class]="btn.class"></button>
                </span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>

  <!-- Scroll to Top Button -->
  <div class="scroll-to-top-button" [class.visible]="showScrollToTopButton" (click)="scrollToTop()" title="Go to Top">
    <i class="fa fa-chevron-up"></i>
  </div>
</div>